import FilterProperties from './filterProperties'

export default FilterProperties
